module.exports = __webpack_public_path__ + "img/mlb-back-2-p-500.b0d541a4.png";